<template>
  <div class="dl">
    <img class="main-logo" src="../assets/logo.png" />
    <div class="content-container">
      <div class="content">
        <h1>
          From birkenbeul
          <br />with love
        </h1>
      </div>
    </div>
    <button v-if="!dlInProgress && !downloadFinished && !downloadError" class="btn" @click="downloadFromServer">Download!</button>
    <div v-if="dlInProgress" style="position:relative" class="status-container">
      <div class="cssload-main" v-if="!downloadFinished && !downloadError">
        <div class="cssload-heart">
          <span class="cssload-heartL"></span>
          <span class="cssload-heartR"></span>
          <span class="cssload-square"></span>
        </div>
        <div class="cssload-shadow"></div>
      </div>
      <div style="text-align:center;top:100px;position:relative">
        <div v-if="!downloadError">
          <span v-if="!downloadFinished">Ihr Download ist im Gange, bitte noch etwas Geduld.</span>
          <span v-else class="finished">Fertig! &#127774;</span>
          <br><br>
          <span v-if="!downloadFinished" class="percent">{{this.downloadProgress}}&thinsp;%</span>
        </div>
        <div v-else>
          Es tut uns, leid. Es ist leider etwas schief gelaufen. Bitte probieren Sie es erneut.
        </div>
      </div>
    </div>

    <footer>
      Copyright © 2008-2025 birkenbeul communications GmbH
      <br />
      <a href="https://birkenbeul.com/datenschutz/">Datenschutz</a> |
      <a href="https://birkenbeul.com/impressum/">Impressum</a>
    </footer>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  data() {
    return {
      downloadURL: window.location.protocol + "//" + window.location.host + "/api/download/",
      dlInProgress: false,
      downloadProgress: 0,
      downloadFinished: false,
      downloadError: false
    };
  },
  methods: {
    saveFile(response) {
      if(window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/zip' }), "birkenbeul.zip");
      } else {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "birkenbeul.zip"); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    },
    downloadFromServer() {
      this.dlInProgress = true
      const vm = this;
      const hash = this.$route.params.hash;

      Axios({
        method: "get",
        url: vm.downloadURL + hash,
        responseType: "arraybuffer",
        onDownloadProgress: progressEvent => {
          if (!progressEvent.total || !progressEvent.loaded) return
          this.downloadProgress = Math.floor((100 / progressEvent.total) * progressEvent.loaded)
        }
      })
      .then(response => {
        vm.saveFile(response);
        //this.dlInProgress = false
        this.downloadFinished = true
      })
      .catch(e => {
        console.log("error occured", e)
        this.dlInProgress = false
        this.downloadError = true
      });
    }
  },
  created() {
    // this.downloadFromServer();
  }
};
</script>

<style scoped>
.dl {
  position: relative;
	display: flex;
	flex-direction: column;
  min-height: calc(100vh - 200px);
	justify-content: space-between;
}
.percent {
  color: #c00070;
  font-weight:bold;
  font-size: 24px;
}
.finished {
  font-size: 30px;
  font-weight: bold;
  color: #c00070;
}
.content-container {
  position: relative;
  height: 300px;
	margin-top: -100px;
}
.content {
  position: absolute;
  white-space: nowrap;
  left: 50%;
  transform: translate(-50%);
  font-size: 3em;
  color: #c00070;
}

.status-container {
	margin-bottom: 30px;
	position: relative;
}

.main-logo {
  width: 85.25px;
  height: 64px;
  margin-left:10px;
  margin-top:10px;
}

.btn {
  background-color: #c00070;
  border: none;
  color: white;
  padding: 17px 35px;
  text-align: center;
  text-decoration: none;
  display: block;
  font-size: 20px;
  transition: background-color 0.5s, color 0.5s;
  border-radius: 50px;
  margin: 0 auto;
  text-align: center;
}
.btn:hover {
  background-color: #990152;
}

.btn:disabled,
.btn[disabled] {
  background-color: #343342;
}

footer {
  background-color: #343342;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
  color: #797887;
  text-align: center;
  line-height: 2;
	padding: 15px;
	box-sizing: border-box;
}

footer a,
footer a:visited {
  color: white;
  text-decoration: none;
}

footer a:hover,
footer a:active {
  text-decoration: underline;
}

@media only screen and (max-width: 1090px) {
  .content {
    font-size: 2em;
  }
}
@media only screen and (max-width: 816px) {
  .content {
    font-size: 1em;
  }
}

.cssload-main {
	position: absolute;
	content: '';
	left: 50%;
	transform: translate(-100%, -240%);
		-o-transform: translate(-100%, -240%);
		-ms-transform: translate(-100%, -240%);
		-webkit-transform: translate(-100%, -240%);
		-moz-transform: translate(-100%, -240%);
}

.cssload-main *{
	font-size:62px;
}

.cssload-heart {
	animation: cssload-heart 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-o-animation: cssload-heart 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-ms-animation: cssload-heart 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-webkit-animation: cssload-heart 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-moz-animation: cssload-heart 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
	top: 50%;
	content: '';
	left: 50%;
	position: absolute;
}

.cssload-heartL {
	width: 1em;
	height: 1em;
	border: 1px solid rgb(192,0,112);
	background-color: rgb(192,0,112);
	content: '';
	position: absolute;
	display: block;
	border-radius: 100%;
	animation: cssload-heartL 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-o-animation: cssload-heartL 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-ms-animation: cssload-heartL 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-webkit-animation: cssload-heartL 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-moz-animation: cssload-heartL 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
	transform: translate(-28px, -27px);
		-o-transform: translate(-28px, -27px);
		-ms-transform: translate(-28px, -27px);
		-webkit-transform: translate(-28px, -27px);
		-moz-transform: translate(-28px, -27px);
}

.cssload-heartR {
	width: 1em;
	height: 1em;
	border: 1px solid rgb(192,0,112);
	background-color: rgb(192,0,112);
	content: '';
	position: absolute;
	display: block;
	border-radius: 100%;
	transform: translate(28px, -27px);
		-o-transform: translate(28px, -27px);
		-ms-transform: translate(28px, -27px);
		-webkit-transform: translate(28px, -27px);
		-moz-transform: translate(28px, -27px);
	animation: cssload-heartR 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-o-animation: cssload-heartR 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-ms-animation: cssload-heartR 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-webkit-animation: cssload-heartR 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-moz-animation: cssload-heartR 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
}

.cssload-square {
	width: 1em;
	height: 1em;
	border: 1px solid rgb(192,0,112);
	background-color: rgb(192,0,112);
	position: relative;
	display: block;
	content: '';
	transform: scale(1) rotate(-45deg);
		-o-transform: scale(1) rotate(-45deg);
		-ms-transform: scale(1) rotate(-45deg);
		-webkit-transform: scale(1) rotate(-45deg);
		-moz-transform: scale(1) rotate(-45deg);
	animation: cssload-square 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-o-animation: cssload-square 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-ms-animation: cssload-square 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-webkit-animation: cssload-square 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-moz-animation: cssload-square 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
}

.cssload-shadow {
	top: 97px;
	left: 50%;
	content: '';
	position: relative;
	display: block;
	bottom: -.5em;
	width: 1em;
	height: .24em;
	background-color: rgb(215,215,215);
	border: 1px solid rgb(215,215,215);
	border-radius: 50%;
	animation: cssload-shadow 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-o-animation: cssload-shadow 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-ms-animation: cssload-shadow 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-webkit-animation: cssload-shadow 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
		-moz-animation: cssload-shadow 2.88s cubic-bezier(0.75, 0, 0.5, 1) infinite normal;
}







@keyframes cssload-square {
	50% {
		border-radius: 100%;
		transform: scale(0.5) rotate(-45deg);
	}
	100% {
		transform: scale(1) rotate(-45deg);
	}
}

@-o-keyframes cssload-square {
	50% {
		border-radius: 100%;
		-o-transform: scale(0.5) rotate(-45deg);
	}
	100% {
		-o-transform: scale(1) rotate(-45deg);
	}
}

@-ms-keyframes cssload-square {
	50% {
		border-radius: 100%;
		-ms-transform: scale(0.5) rotate(-45deg);
	}
	100% {
		-ms-transform: scale(1) rotate(-45deg);
	}
}

@-webkit-keyframes cssload-square {
	50% {
		border-radius: 100%;
		-webkit-transform: scale(0.5) rotate(-45deg);
	}
	100% {
		-webkit-transform: scale(1) rotate(-45deg);
	}
}

@-moz-keyframes cssload-square {
	50% {
		border-radius: 100%;
		-moz-transform: scale(0.5) rotate(-45deg);
	}
	100% {
		-moz-transform: scale(1) rotate(-45deg);
	}
}

@keyframes cssload-heart {
	50% {
		transform: rotate(360deg);
	}
	100% {
		transform: rotate(720deg);
	}
}

@-o-keyframes cssload-heart {
	50% {
		-o-transform: rotate(360deg);
	}
	100% {
		-o-transform: rotate(720deg);
	}
}

@-ms-keyframes cssload-heart {
	50% {
		-ms-transform: rotate(360deg);
	}
	100% {
		-ms-transform: rotate(720deg);
	}
}

@-webkit-keyframes cssload-heart {
	50% {
		-webkit-transform: rotate(360deg);
	}
	100% {
		-webkit-transform: rotate(720deg);
	}
}

@-moz-keyframes cssload-heart {
	50% {
		-moz-transform: rotate(360deg);
	}
	100% {
		-moz-transform: rotate(720deg);
	}
}

@keyframes cssload-heartL {
	60% {
		transform: scale(0.4);
	}
}

@-o-keyframes cssload-heartL {
	60% {
		-o-transform: scale(0.4);
	}
}

@-ms-keyframes cssload-heartL {
	60% {
		-ms-transform: scale(0.4);
	}
}

@-webkit-keyframes cssload-heartL {
	60% {
		-webkit-transform: scale(0.4);
	}
}

@-moz-keyframes cssload-heartL {
	60% {
		-moz-transform: scale(0.4);
	}
}

@keyframes cssload-heartR {
	40% {
		transform: scale(0.4);
	}
}

@-o-keyframes cssload-heartR {
	40% {
		-o-transform: scale(0.4);
	}
}

@-ms-keyframes cssload-heartR {
	40% {
		-ms-transform: scale(0.4);
	}
}

@-webkit-keyframes cssload-heartR {
	40% {
		-webkit-transform: scale(0.4);
	}
}

@-moz-keyframes cssload-heartR {
	40% {
		-moz-transform: scale(0.4);
	}
}

@keyframes cssload-shadow {
	50% {
		transform: scale(0.5);
		border-color: rgb(228,228,228);
	}
}

@-o-keyframes cssload-shadow {
	50% {
		-o-transform: scale(0.5);
		border-color: rgb(228,228,228);
	}
}

@-ms-keyframes cssload-shadow {
	50% {
		-ms-transform: scale(0.5);
		border-color: rgb(228,228,228);
	}
}

@-webkit-keyframes cssload-shadow {
	50% {
		-webkit-transform: scale(0.5);
		border-color: rgb(228,228,228);
	}
}

@-moz-keyframes cssload-shadow {
	50% {
		-moz-transform: scale(0.5);
		border-color: rgb(228,228,228);
	}
}
</style>
